import { useNavigationQuery } from '@contentfulTypes'
import { useRouter } from 'next/router'
import { DEFAULT_LOCALE } from '~/config/constants'
import { createGraphQLClient } from '~/graphql/contentfulClient'
import { usePreviewMode } from '~/hooks/usePreviewMode'
import { createLanguageRegionLocale } from '~/lib/createLanguageRegionLocale'
import { Image } from '@next/image'
import { useInView } from 'react-intersection-observer'

export const Benefits = () => {
  const preview = usePreviewMode()
  const contentfulClient = createGraphQLClient({ preview })
  const router = useRouter()
  const { data } = useNavigationQuery(contentfulClient, {
    preview,
    locale: router.locale ? createLanguageRegionLocale(router.locale) : DEFAULT_LOCALE,
  })
  const { ref, inView } = useInView({ triggerOnce: true })
  if (!data) return null

  return (
    <ul ref={ref} className="mt-10 px-4 lg:mb-0 lg:px-0">
      {data?.pageCollection?.items?.[0]?.productBenefitsCollection?.items?.map((item) => (
        <li
          key={item?.sys?.id}
          className="mb-2 flex flex-nowrap items-center text-p font-extralight last:mb-0"
        >
          {inView && (
            <Image
              width={24}
              height={24}
              src={item?.icon?.url}
              alt={item?.icon?.title as string}
              className="mr-4"
              loading="lazy"
            />
          )}
          <span
            dangerouslySetInnerHTML={{
              __html: item?.title?.replace(
                '{{days}}',
                data?.pageCollection?.items[0]?.deliveryDays as string,
              ) as string,
            }}
          />
        </li>
      ))}
    </ul>
  )
}
